import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './SearchFiltersModalV2.module.css';

const TextChip = props => {
  const { option, selected, compact, onClick } = props;

  return (
    <button
      key={option.key}
      type="button"
      className={classNames(compact ? css.segmentChip : css.textChip, {
        [css.segmentChipSelected]: compact && selected,
        [css.textChipSelected]: !compact && selected,
      })}
      onClick={onClick}
    >
      {option.label}
    </button>
  );
};

TextChip.defaultProps = {
  selected: false,
  compact: false,
};

TextChip.propTypes = {
  option: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  selected: PropTypes.bool,
  compact: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default TextChip;
